
 
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import {Observable, pipe, throwError} from 'rxjs';
 import {map, tap} from 'rxjs/operators';
import decode from 'jwt-decode';
import { HttpClient } from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import {AppSettings} from '../settings';
declare var $:any;
 
@Injectable({
  providedIn: 'root'
})
export class CommonService {



  constructor() {

    
   }


   
   check_newsletter_mange_exists(permissions){
     
    return permissions.indexOf("manage_newsletter") > -1;

  }


  check_newsletter_control_exists(permissions){
     
    return  permissions.indexOf("control_newsletter") > -1;

  }

  check_newsletter_message_exists(permissions){

    return  permissions.indexOf("control_newsletter") > -1 ||  permissions.indexOf("manage_newsletter") > -1;
  }

  check_newsletter_create_exists(permissions){
            
   // return permissions.indexOf("control_newsletter") > -1 ||  permissions.indexOf("create_newsletter") > -1 ||  permissions.indexOf("manage_newsletter") > -1;

   return  permissions.indexOf("create_newsletter") > -1 ;

  }

  check_newsletter_status_filter_exists(permissions){

//    return  permissions.indexOf("control_newsletter") >  -1 || permissions.indexOf("create_newsletter") > -1 ||  permissions.indexOf("manage_newsletter") > -1;
    return  permissions.indexOf("manage_newsletter") > -1;


  }




   
   check_mange_exists(permissions){
     
    return permissions.indexOf("manage_article") > -1;

  }


  check_control_exists(permissions){
     
    return  permissions.indexOf("control_article") > -1;

  }

  check_message_exists(permissions){

    return  permissions.indexOf("control_article") > -1 ||  permissions.indexOf("manage_article") > -1;
  }

  check_create_exists(permissions){
            
    return permissions.indexOf("control_article") > -1 ||  permissions.indexOf("create_article") > -1 ||  permissions.indexOf("manage_article") > -1;

  }

  check_status_filter_exists(permissions){

    return  permissions.indexOf("control_article") >  -1 || permissions.indexOf("create_article") > -1 ||  permissions.indexOf("manage_article") > -1;

  }

   getMinimumString(str:string,len:number){

        return (str.length > len)? str.substr(0,len)+'..': str;      

   }


  getHtmlforPresent(s:string){

    
    //    var $s = $(s);
    //     $s.find("*").not("p").each(function() {
    //         $(this).replaceWith(this.innerHTML);
    //     });

    //    return $s.html();

       var tmp = document.createElement("DIV");
       tmp.innerHTML = s;
       return tmp.textContent || tmp.innerText || "";
  }


  getfilename(fname:string){

    if(fname.length ==0 ){

        return ;
    
    } else {

        let f_underscore=  0;     
         if(fname.indexOf('_') != -1) { 
           f_underscore = fname.indexOf('_')+1;
        }         
        
        let exp = fname.lastIndexOf('.'); 
       
        let str = fname.substring(f_underscore,exp); 
        if(str.length > 10) {
          str = str.substring(0,10)+'..';
        }

      
        let filename = str +fname.substring(exp);


        return filename;


    }


  }
/*
  getMinimumString(str:string,len:number){

    return (str.length > len)? str.substr(0,len)+'..': str; 
    
    }*/

}